export const productKeys = {
  all: ['products'] as const,
  lists: () => [...productKeys.all, 'list'] as const,
  list: (companyId: string) => [...productKeys.lists(), companyId] as const,
  details: () => [...productKeys.all, 'detail'] as const,
  detail: (id: string) => [...productKeys.details(), id] as const,
  byCompany: (companyId: string) => ['products', 'byCompany', companyId] as const,
}
